import {qiniuResource as qr} from '@/utils/common'

export const qiniuResource = value => {
	return qr(value)
}